import { useCallback } from 'react';
import { ErrorBoundary } from '@sentry/react';
import type { FallbackRender } from '@sentry/react/dist/errorboundary';
import loadable from '@loadable/component';

const Oops = loadable(() => import('@components/Oops'));
const OutdatedApp = loadable(() => import('@components/Oops/OutdatedApp'), {
  resolveComponent: (component) => component.OutdatedApp,
});
interface Props {
  children: React.ReactNode;
}
export function Sentry(props: Props) {
  const fallbackHandler = useCallback<FallbackRender>((args) => {
    if (args.error.name.toLowerCase().includes('chunkloaderror')) {
      return <OutdatedApp />;
    }
    return <Oops />;
  }, []);
  return (
    <ErrorBoundary fallback={fallbackHandler}>{props.children}</ErrorBoundary>
  );
}
